/** "✓ Saved" just after a save, "Unsaved changes" once something is edited, else nothing. */
import { Check } from 'lucide-react';

export interface EditorSaveStateProps {
  saved: boolean;
  unsaved: boolean;
  className?: string;
}

export function EditorSaveState({ saved, unsaved, className }: EditorSaveStateProps) {
  return (
    <span role="status" className={className} style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
      {saved && (
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            fontWeight: 700,
            color: 'var(--nb-primary-2)',
          }}
        >
          <Check size={14} aria-hidden />
          Saved
        </span>
      )}
      {unsaved && <span style={{ color: 'var(--nb-subtle)' }}>Unsaved changes</span>}
    </span>
  );
}
